<template>
  <UserForm :typeEndPoint="'adminUsersShow'" :dataParams="this.$route.params" />
</template>
<script>
import UserForm from '@/components/modules/admin/users/form'
export default {
  name: 'UserFormEdit',
  components: {
    UserForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/users/edit.vue